import {Sprite, Text} from 'pixi.js';
import {Button, DeviceType, inject, State, Text as CoreText} from '@gongxigames/framework/core';
import {ILogic} from '@gongxigames/framework/slot/types';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';
import {KeypadInfoElementsView} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsView';
import {KeypadView, KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad';

export class KeypadInfoElementsViewMobileLandscape extends KeypadInfoElementsView {
    public static readonly NAME: symbol = Symbol('KeypadInfoElementsViewMobileLandscape');
    public static layer = LAYERS.KEYPAD;
    public static platform = DeviceType.MOBILE;

    @inject(DI.Logic)
    private _logic!: ILogic;

    private _totalBetPanelBet!: Text;
    private _spinsLeftButton!: Button;

    protected initGraphicElements(): void {
        this._balancePanel = this.mainSprite.getChildByName<Sprite>('balancePanel');
        this.balanceLabel =
            (this.mainSprite.getChildByName<Sprite>('balancePanel')).getChildByName<Text>('label');
        this._freeSpinsInfoPanel = this.mainSprite.getChildByName<Sprite>('fgPanel');
        this._leftTicker = this.mainSprite.getChildByName('tickerLeft') as Text;
        this._rightTicker = this.mainSprite.getChildByName('tickerRight') as Text;
        this._pointsBalance = this.mainSprite.getChildByName('pointsBalance') as Text;
        const totalBetPanelLandscape: Sprite = this.mainSprite.getChildByName<Sprite>('totalBetPanel');

        this._totalBetPanelBet = totalBetPanelLandscape.getChildByName<Text>('fieldText');
        this.betLabel = totalBetPanelLandscape.getChildByName<Text>('label');
        this._spinsLeftButton = this.mainSprite.getChildByName<Button>('spinsLeftButton');
    }

    public initializeMainGameLayout(): void {
        this._totalBetPanelBet.visible = this.getSettings<SlotSettings>().get('showBet');
        this._balancePanel.getChildByName('fieldText').visible = this.getSettings<SlotSettings>().get('showBalance');

        if (this.getSettings<SlotSettings>().get('isPointsCurrencyEnabled')) {
            this._rightTicker.visible = false;
            this._pointsBalance.visible = true;
        } else {
            this._pointsBalance.visible = false;
        }
    }

    public initializeFreeSpinsLayout(): void {
        this._totalBetPanelBet.visible = this.getSettings<SlotSettings>().get('showBet');
        this._balancePanel.getChildByName('fieldText').visible = this.getSettings<SlotSettings>().get('showBalance');
    }

    public refreshFreeSpinsInfo(freeSpinsLeft: number, freeSpinsTotal: number): void {
        for (const frameKey in this._spinsLeftButton.frames) {
            if (this._spinsLeftButton.frames.hasOwnProperty(frameKey)) {
                const frame = this._spinsLeftButton.frames[frameKey as State];
                const textField = (frame as Sprite).getChildByName<CoreText>('txt');

                textField.text = String(freeSpinsTotal - freeSpinsLeft);
            }
        }
    }

    public refreshBalance(balance: number): void {
        (this._balancePanel.getChildByName<Text>('fieldText')).text = this._currencyFormatter.formatCents(balance, true);
    }

    public refreshPointsBalance(points: number): void {
        this._pointsBalance.text = `${this._languageService.get('pointsLabel')}: ${this._currencyFormatter.formatCents(points)}`;
    }

    public spinsLeftButtonClickAction(): void {
        this._spinsLeftButton.disable();
    }

    public refreshTotalBetInfo(totalBetValue: string): void {
        this._totalBetPanelBet.text = totalBetValue;
    }

    public set spinsLeftButton(value: Button) {
        this._spinsLeftButton = value;
    }

    public set betLabel(value: Text) {
        value.text = this._languageService.get('totalBetLabel');
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobileLandscape.NAME];
    }
}
